import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $mediaContactTitle, $contact, $regionTitle': {
      color: TextColors.light,
    },

    '& $contactEmail': {
      color: SecondaryColors.main,

      '&:hover': {
        color: SecondaryColors.light,
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $mediaContactTitle, $contact, $regionTitle': {
      color: TextColors.dark,
    },

    '& $contactEmail': {
      color: SecondaryColors.dark,

      '&:hover': {
        color: SecondaryColors.main,
      },
    },
  },
};

const useStyles = makeStyles(
  () => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      marginTop: '32px',

      '& > *:not(:first-child)': {
        '& h4:first-child': {
          marginTop: '32px',
        },
      },
    },
    mediaContactTitle: {
      '&.MuiTypography-root': {
        marginBottom: '10px',
      },
    },
    contact: {
      marginTop: '16px',

      '& .MuiTypography-root': {
        marginBottom: '4px',
      },

      '& a.MuiTypography-root': {
        display: 'block',
      },
    },
    contactEmail: {
      '&.MuiTypography-root': {
        fontWeight: 'normal',
        cursor: 'pointer',
        textDecoration: 'none',

        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
    contactPhone: {
      '&.MuiTypography-root': {
        fontWeight: 'normal',
        cursor: 'pointer',
        textDecoration: 'none',

        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
    regionTitle: {
      '&.MuiTypography-root': {
        textTransform: 'uppercase',
        marginTop: '16px',
        marginBottom: 0,

        '&:first-child': {
          marginTop: '24px',
        },
      },
    },
  }),
  { name: 'GenPressReleaseMediaContacts' },
);

export default useStyles;
